var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      key: _vm.curkey,
      staticClass: "primary fill-height d-flex justify-center",
      style: {
        minHeight: "580px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "678px 561px",
        height: "100%",
        position: "relative",
        overflow: "hidden",
      },
      attrs: { fluid: "", id: "loginContainer" },
    },
    [
      !_vm.show
        ? _c("v-progress-circular", {
            attrs: {
              indeterminate: "",
              color: "white",
              size: "20",
              width: "1",
            },
          })
        : _vm._e(),
      _vm.showDialog
        ? _c(
            "v-card",
            {
              staticClass: "logo_module",
              attrs: {
                elevation: "24",
                width: "480",
                height: "auto",
                rounded: "",
              },
            },
            [
              _c("v-card-title", { staticClass: "pa-0 pt-8" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("label_essweb_login_secondVertifyTitle")) +
                    " "
                ),
              ]),
              _c("v-card-subtitle", { staticClass: "pa-0 pt-4" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("label_essweb_login_secondVertifySubTitle")) +
                    " "
                ),
                _c("span", { staticClass: "text--primary" }, [
                  _vm._v(_vm._s(_vm.account)),
                ]),
              ]),
              _c(
                "v-card-text",
                {
                  staticClass: "pa-0",
                  staticStyle: { "padding-top": "44px !important" },
                },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form2",
                      attrs: { "lazy-validation": "", dense: "" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "ml-0 mr-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-body-1 ma-0",
                                attrs: {
                                  maxlength: "50",
                                  placeholder: _vm.$t(
                                    "label_essweb_login_emailCodeLabel"
                                  ),
                                  color: "primary",
                                  height: "44",
                                  rules: _vm.$GetRules(
                                    ["_Require_Rules"],
                                    [
                                      _vm.$t(
                                        "label_essweb_login_emailCodeLabel"
                                      ),
                                    ]
                                  ),
                                  "hide-details": "",
                                  required: "",
                                  "aria-autocomplete": false,
                                  autofocus: false,
                                },
                                model: {
                                  value: _vm.email_code,
                                  callback: function ($$v) {
                                    _vm.email_code = $$v
                                  },
                                  expression: "email_code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 my-3",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _vm.second == 0
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize",
                                      attrs: {
                                        color: "primary",
                                        rounded: "",
                                        text: "",
                                      },
                                      on: { click: _vm.reSendCode },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_form_tools_reSendCodeBtnLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_login_canResendCodeLabel",
                                            { time: _vm.second + "s" }
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-end pb-8" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-capitalize px-12",
                      attrs: { color: "primary", rounded: "", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showDialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("label_essweb_form_tools_backBtnLabel"))
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-capitalize px-12",
                      attrs: {
                        color: "primary",
                        disabled: !_vm.email_code,
                        loading: _vm.isLoading2,
                        rounded: "",
                      },
                      on: { click: _vm.secondLogin },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("label_essweb_form_tools_submitBtnLabel"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("svg-icon", {
        staticClass: "left_bg",
        style: {
          left: -_vm.bgstyle / 2 + "px",
        },
        attrs: { size: _vm.bgstyle, iconClass: "left" },
      }),
      _c("svg-icon", {
        staticClass: "right_bg",
        style: {
          right: -_vm.bgstyle / 2 + "px",
        },
        attrs: { size: _vm.bgstyle, iconClass: "right" },
      }),
      _vm.show && !_vm.showDialog
        ? _c(
            "v-card",
            {
              staticClass: "logo_module",
              attrs: {
                elevation: "24",
                transition: "scale-transition",
                rounded: "",
              },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex justify-space-between pa-0 pt-8",
                  staticStyle: { "flex-wrap": "nowrap" },
                },
                [
                  _c("svg-icon", {
                    attrs: {
                      width: "171px",
                      height: "58px",
                      iconClass: _vm.logo,
                    },
                  }),
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "", small: "", "max-height": "300" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-sheet",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "\n              text-button\n              ma-0\n              pa-2\n              mt-5\n              text-capitalize\n              d-flex\n              align-center\n              text--secondary\n            ",
                                    },
                                    on
                                  ),
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "px-1 text-truncate" },
                                      [_vm._v(" " + _vm._s(_vm.showLang) + " ")]
                                    ),
                                    _c("v-spacer"),
                                    _c(
                                      "i",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("arrow_drop_down")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        799556030
                      ),
                    },
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.companyLang, function (item, index) {
                          return _c(
                            "v-list-item",
                            {
                              key: index,
                              on: {
                                click: function ($event) {
                                  return _vm.setLang(item["value"])
                                },
                              },
                            },
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(item["text"])),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                {
                  staticClass: "pa-0",
                  staticStyle: { "padding-top": "44px !important" },
                },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "", dense: "" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "ml-0 mr-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-body-1 ma-0",
                                attrs: {
                                  maxlength: "50",
                                  placeholder:
                                    _vm.$t(
                                      "label_essweb_login_accountNameLabel"
                                    ) +
                                    " / " +
                                    _vm.$t("label_essweb_login_mailLabel"),
                                  color: "primary",
                                  height: "44",
                                  rules: _vm.$GetRules(
                                    ["_Require_Rules"],
                                    [
                                      _vm.$t(
                                        "label_essweb_login_accountNameLabel"
                                      ) +
                                        " / " +
                                        _vm.$t("label_essweb_login_mailLabel"),
                                    ]
                                  ),
                                  required: "",
                                  "aria-autocomplete": false,
                                  autofocus: false,
                                },
                                model: {
                                  value: _vm.account,
                                  callback: function ($$v) {
                                    _vm.account = $$v
                                  },
                                  expression: "account",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 pb-2",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-body-1 ma-0",
                                style: {
                                  font:
                                    _vm.passType === "password"
                                      ? "caption !important"
                                      : "inherit",
                                },
                                attrs: {
                                  color: "primary",
                                  placeholder: _vm.$t(
                                    "label_essweb_login_passwordLabel"
                                  ),
                                  height: "44",
                                  maxlength: "50",
                                  type: _vm.passType,
                                  rules: _vm.$GetRules(
                                    ["_Require_Rules", "_Length_Rules"],
                                    [
                                      _vm.$t(
                                        "label_essweb_login_passwordLabel"
                                      ),
                                      30,
                                    ]
                                  ),
                                  required: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mt-2",
                                              on: {
                                                click: function ($event) {
                                                  _vm.passType == "text"
                                                    ? (_vm.passType =
                                                        "password")
                                                    : (_vm.passType = "text")
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.passIcon))]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3568935448
                                ),
                                model: {
                                  value: _vm.password,
                                  callback: function ($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              staticStyle: {
                                "padding-bottom": "32px !important",
                              },
                              attrs: { cols: "12" },
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0 pa-0",
                                attrs: {
                                  color: "primary",
                                  height: "20",
                                  "hide-details": "",
                                  label: _vm.$t(
                                    "label_essweb_login_rememberMeLabel"
                                  ),
                                  required: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-sm-caption text-body-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_login_rememberMeLabel"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2255565390
                                ),
                                model: {
                                  value: _vm.remember,
                                  callback: function ($$v) {
                                    _vm.remember = $$v
                                  },
                                  expression: "remember",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 text-center pb-6",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "text-capitalize text-button white--text",
                                  staticStyle: {
                                    width: "50%",
                                    "min-width": "256px",
                                    height: "48px",
                                    "letter-spacing": "0.0125em !important",
                                  },
                                  attrs: {
                                    rounded: "",
                                    large: "",
                                    loading: _vm.isLoading,
                                    color: "primary",
                                  },
                                  on: { click: _vm.toLogin },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("label_essweb_login_loginBtnLabel")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "align-items-end text-center pa-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "text-capitalize text--secondary text-button px-0",
                                  attrs: {
                                    text: "",
                                    depressed: "",
                                    height: "20",
                                    tile: "",
                                    "retain-focus-on-click": true,
                                  },
                                  on: { click: _vm.forgetPassword },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_login_forgetPasswordLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.show
        ? _c(
            "v-sheet",
            {
              staticClass: "text-center footer-container max-width transparent",
            },
            [
              _c("Footer", {
                attrs: {
                  fontColor: "rgba(255, 255, 255, 0.68)",
                  contentClass: "pa-0 ma-0 pt-2",
                  linkReverse: "",
                  center: "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          staticClass: "animated slideInUp",
          attrs: { bootom: "", color: _vm.MsgStatus.color, timeout: 3000 },
          on: {
            input: function ($event) {
              _vm.MsgStatus.show = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.MsgStatus.show = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [
                      _c("span", { staticClass: "material-icons-round" }, [
                        _vm._v("highlight_off"),
                      ]),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.MsgStatus.show,
            callback: function ($$v) {
              _vm.$set(_vm.MsgStatus, "show", $$v)
            },
            expression: "MsgStatus.show",
          },
        },
        [_vm._v(" " + _vm._s(_vm.MsgStatus.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }